import React from "react";
import { Trophy, TrendingUp, Star, Briefcase, CheckCircle, Linkedin, Award } from "lucide-react";
import './About.css';

function About() {
  return (
    <section id="about" className="about-page page-section">
      <div className="section-divider"><div></div></div>
      <div className="about-hero">
        <h1>About ILGI Tech Solutions</h1>
        <p>Innovative Software Development & IT Consulting since 2021</p>
      </div>

      <div className="about-content">
        <section className="company-section">
          <h2>Our Company</h2>
          <p>
            ILGI Tech Solutions is a forward-thinking software development company founded in 2021, 
            dedicated to delivering cutting-edge technology solutions. We specialize in custom software 
            development, cloud solutions, and IT consulting services.
          </p>
          
          <div className="stats-grid">
            <div className="stat-box">
              <div className="stat-icon"><Trophy size={32} /></div>
              <h3>#1 Ranking</h3>
              <p>Top Microenterprises in Târgu Jiu</p>
            </div>
          </div>

          <div className="company-details">
            <h3>Company Information</h3>
            <ul>
              <li><strong>Legal Name:</strong> ILGI TECH SOLUTIONS SRL</li>
              <li><strong>CUI:</strong> 45152041</li>
              <li><strong>Registration Number:</strong> J18/1241/2021</li>
              <li><strong>EUID:</strong> ROONRC.J18/1241/2021</li>
              <li><strong>Founded:</strong> 2021</li>
              <li><strong>Location:</strong> Loc. Drăgoeni, Nr. 97A, Gorj, Romania</li>
              <li><strong>Main Activity:</strong> Custom Software Development (CAEN 6201)</li>
            </ul>
          </div>
        </section>

        <section className="ceo-section">
          <h2>Leadership</h2>
          <div className="ceo-card-about">
            <h3>Laurentiu Trasca</h3>
            <p className="ceo-role">Chief Executive Officer & Founder</p>
            
            <p className="ceo-bio">
              Founded and led by <strong>Laurentiu Trasca</strong>, a certified technology professional with 
              expertise in cloud computing, DevOps, and modern software development practices. His industry-recognized 
              certifications and leadership have positioned ILGI Tech Solutions as a trusted partner for businesses 
              seeking innovative technology solutions.
            </p>

            <div className="certifications-section">
              <h4>Professional Certifications</h4>
              <div className="cert-list">
                <div className="cert-badge">
                  <span className="cert-icon"><CheckCircle size={18} /></span>
                  <span>AWS Certified Solutions Architect</span>
                </div>
                <div className="cert-badge">
                  <span className="cert-icon"><CheckCircle size={18} /></span>
                  <span>Azure Fundamentals Certified</span>
                </div>
                <div className="cert-badge">
                  <span className="cert-icon"><CheckCircle size={18} /></span>
                  <span>Professional Cloud Architect</span>
                </div>
                <div className="cert-badge">
                  <span className="cert-icon"><CheckCircle size={18} /></span>
                  <span>DevOps & Agile Methodologies Expert</span>
                </div>
              </div>
            </div>

            <div className="ceo-links-about">
              <a
                href="https://www.linkedin.com/in/trasca-laurentiu-a377ab123/"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-link linkedin"
                aria-label="View Laurentiu Trasca's LinkedIn profile"
              >
                <Linkedin size={18} />
                <span>LinkedIn Profile</span>
              </a>
              <a
                href="https://www.credly.com/users/ilie-laurentiu-trasca/badges"
                target="_blank"
                rel="noopener noreferrer"
                className="profile-link credly"
                aria-label="View certifications on Credly"
              >
                <Award size={18} />
                <span>View Certifications</span>
              </a>
            </div>
          </div>
        </section>

        <section className="achievement-section">
          <h2>Our Achievements</h2>
          <div className="achievement-grid">
            <div className="achievement-card">
              <div className="achievement-icon"><Trophy size={28} /></div>
              <h3>#1 Ranking</h3>
              <p>Top Microenterprises in Târgu Jiu for Custom Software Development</p>
            </div>
            <div className="achievement-card">
              <div className="achievement-icon"><TrendingUp size={28} /></div>
              <h3>Rapid Growth</h3>
              <p>Over 10x revenue growth from 2021 to 2024</p>
            </div>
            <div className="achievement-card">
              <div className="achievement-icon"><Star size={28} /></div>
              <h3>Excellence</h3>
              <p>Led by certified cloud and DevOps professionals</p>
            </div>
            <div className="achievement-card">
              <div className="achievement-icon"><Briefcase size={28} /></div>
              <h3>Trusted Partner</h3>
              <p>Delivering innovative solutions since 2021</p>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

export default About;